/** @format */

import React, { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { BeatLoader } from "react-spinners";
import MainWrapper from "./MainWrapper";
import LazyLoading from "../components/LazyLoading/LazyLoading";
// import LandingPage from './LandingPage/LandingPage';
import MainApp from "./MainApp/MainApp";
import Protected from "../components/Protected/Protected";
import RequestNoticeView from "./LegalNotices/RequestNoticeView";
import NoticeDetailView from "./LegalNotices/NoticeDetailView";
import Dashboard from "./Dashboard";
import CaseCreatePage from "./CaseManagement/CaseCreatePage";
import CaseDetailsPage from "./CaseManagement/CaseDetailsPage";
import CaseListingPage from "./CaseManagement/CaseListingPage";
import Tasks from "./Tasks";
import AgreementsListingPage from "./AgreementsManager/AgreementsListingPage";
import AgreementCreatePage from "./AgreementsManager/AgreementCreatePage";
import AgreementBulkCreate from "./AgreementsManager/BulkAgreement/AgreementBulkCreate";
import CaseFormNew from "./CaseFormNew";
import DashboardNew from "./DashboardNew";
import RecoveryDashboard from "./RecoveryDashboard";
import NotificationsPage from "./NotificationsPage";
import NoticeRequest from "./NoticeRequest/NoticeRequest";
import NoticesListing from "./LegalNotices/NoticesListing";
import NoticeCreatePage from "./LegalNotices/NoticeCreation/NoticeCreatePage";
import NoticeDetailsPage from "./LegalNotices/NoticeDetailsPage";
import TemplatesList from "../components/TemplateManager/TemplatesList";
import TemplateForm from "../components/TemplateManager/TemplateForm";
import NewLandingPageRedirect from "./NewLandingPageRedirect";
import LandingPage from "./LandingPage/LandingPage";
import ServiceProviderList from "./ServiceProvider/ServiceProviderList";
import BudgetManager from "./BudgetManager/BudgetManager";
import LoginPage from "./LoginPage";
// import ServiceProviderDetail from '../components/ServiceProviderDetail/ServiceProviderDetail';
import ServiceProviderDetails from "./ServiceProvider/ServiceProviderDetails";
import TemplateEditor from "../components/TemplateManager/TemplateEditor";
import Search from "./Search";
import Blogs from "./Blogs/Blogs";
import CreateBlogs from "./Blogs/CreateBlogs";
import Clause from "./Clause/Clause";
import CreateClause from "./Clause/CreateClause";
import Document from "./DocumentSection/Document";
import AddOrganisationPage from "./../components/AddOrganisation/AddOrganisationPage";
// import AgreementDetailsPage from './AgreementsManager/AgreementDetailsPage';
const AgreementDetailsPage = lazy(() =>
  import("./AgreementsManager/AgreementDetailsPage")
);
import AddOrganisationDetail from "./../components/AddOrganisation/AddOrganizationDetail";
import NewRecoveryPage from "./RecoveryManager/NewRecovery";
import RecoveryListingPage from "./RecoveryManager/RecoveryListingPage";
import RecoveryDisplayPage from "./RecoveryManager/RecoveryDisplayPage";
import ForgotPassword from "../components/Recovery/ForgotPassword";
import UpdatePassword from "../components/Recovery/UpdatePassword";
import NoticeList from "../components/Recovery/NoticeList";
import EmailList from "../components/Recovery/EmailList";
import GmailInbox from "./RecoveryManager/GmailInbox";


const RouteHandler = () => (
  <MainWrapper>
    <Suspense fallback={<LazyLoading />}>
      <Routes>
        <Route
          path="/"
          exact
          element={
            process.env.REACT_APP_ENV === "LOCALHOST" ? (
              <LandingPage />
            ) : (
              <NewLandingPageRedirect />
            )
          }
        />
        <Route path="/app/login/" exact element={<LoginPage />} />
        <Route
          path="/app/forgotPassword"
          exact
          element={<ForgotPassword />}
        />
        <Route path="/request-notice" exact element={<NoticeRequest />} />
        <Route
          path="/app/case-new-form"
          exact
          element={
            <Protected>
              <MainApp appContent={<CaseFormNew />} />
            </Protected>
          }
        />
        <Route
          path="/app-old"
          exact
          element={
            <Protected>
              <MainApp appContent={<Dashboard />} />
            </Protected>
          }
        />
        <Route
          path="/app"
          exact
          element={
            <Protected>
              {/* <MainApp appContent={<DashboardNew />} /> */}
              <MainApp appContent={<RecoveryDashboard />} />
            </Protected>
          }
        />
        <Route
          path="/app/search/:input"
          exact
          element={
            <Protected>
              <MainApp appContent={<Search />} />
            </Protected>
          }
        />
        <Route
          path="/app/notifications"
          exact
          element={
            <Protected>
              <MainApp appContent={<NotificationsPage />} />
            </Protected>
          }
        />
        <Route
          path="/app/tasks"
          exact
          element={
            <Protected>
              <MainApp appContent={<Tasks />} />
            </Protected>
          }
        />
        <Route
          path="/app/dispute-manager/edit-case"
          exact
          element={
            <Protected>
              <MainApp appContent={<CaseCreatePage />} />
            </Protected>
          }
        />
        <Route
          path="/app/dispute-manager/cases"
          exact
          element={
            <Protected>
              <MainApp appContent={<CaseListingPage />} />
            </Protected>
          }
        />
        <Route
          path="/app/dispute-manager/cases/details/:caseId"
          exact
          element={
            <Protected>
              <MainApp appContent={<CaseDetailsPage />} />
            </Protected>
          }
        />
        <Route
          path="/app/dispute-manager/legal-notices/create"
          exact
          element={
            <Protected>
              <MainApp appContent={<NoticeCreatePage />} />
            </Protected>
          }
        />
        <Route
          path="/app/dispute-manager/legal-notices/edit/"
          exact
          element={
            <Protected>
              <MainApp appContent={<NoticeCreatePage />} />
            </Protected>
          }
        />
        <Route
          path="/app/dispute-manager/legal-notices"
          exact
          element={
            <Protected>
              <MainApp appContent={<NoticesListing />} />
            </Protected>
          }
        />
        <Route
          path="/app/dispute-manager/legal-notices/details/:noticeId"
          exact
          element={
            <Protected>
              <MainApp appContent={<NoticeDetailsPage />} />
            </Protected>
          }
        />
        <Route
          path="/app/view/notice-request/:noticeRequestRef"
          exact
          element={
            <Protected>
              <MainApp appContent={<RequestNoticeView />} />
            </Protected>
          }
        />
        <Route
          path="/app/view/notice/:noticeRef"
          exact
          element={
            <Protected>
              <MainApp appContent={<NoticeDetailView />} />
            </Protected>
          }
        />
        {/* <Route
          path="/app/templates"
          exact
          element={(
            <Protected>
              <MainApp appContent={(
                <TemplatesList
                  showEditButton
                  showViewButton={false}
                />
                )}
              />
            </Protected>
          )}
        /> */}
        <Route
          path="/app/templates/agreement"
          exact
          element={
            <Protected>
              <MainApp
                appContent={
                  <TemplatesList
                    templateType="Agreements"
                    showEditButton
                    showViewButton={false}
                  />
                }
              />
            </Protected>
          }
        />
        <Route
          path="/app/templates/notice"
          exact
          element={
            <Protected>
              <MainApp
                appContent={
                  <TemplatesList
                    templateType="Notices"
                    showEditButton
                    showViewButton={false}
                  />
                }
              />
            </Protected>
          }
        />
        <Route
          path="/app/templates/email"
          exact
          element={
            <Protected>
              <MainApp
                appContent={
                  <TemplatesList
                    templateType="Email"
                    showEditButton
                    showViewButton={false}
                  />
                }
              />
            </Protected>
          }
        />
        <Route
          path="/app/templates/clause"
          exact
          element={
            <Protected>
              <MainApp appContent={<Clause />} />
            </Protected>
          }
        />
        <Route
          path="/app/templates/clause/:id"
          exact
          element={
            <Protected>
              <MainApp appContent={<CreateClause />} />
            </Protected>
          }
        />
        <Route
          path="/app/templates/agreements/new"
          exact
          element={
            <Protected>
              <MainApp appContent={<TemplateForm />} />
            </Protected>
          }
        />
        <Route
          path="/app/templates/notices/new"
          exact
          element={
            <Protected>
              <MainApp appContent={<TemplateForm />} />
            </Protected>
          }
        />
        <Route
          path="/app/templates/email/new"
          exact
          element={
            <Protected>
              <MainApp appContent={<TemplateForm />} />
            </Protected>
          }
        />
        <Route
          path="/app/templates/edit/template/:templateId"
          exact
          element={
            <Protected>
              <MainApp appContent={<TemplateEditor />} />
            </Protected>
          }
        />
        <Route
          path="/app/agreements"
          exact
          element={
            <Protected>
              <MainApp appContent={<AgreementsListingPage />} />
            </Protected>
          }
        />
        <Route
          path="/app/agreements/details/:agreementId"
          exact
          element={
            <Protected>
              <MainApp
                appContent={
                  <Suspense fallback={<BeatLoader />}>
                    <AgreementDetailsPage />
                  </Suspense>
                }
              />
            </Protected>
          }
        />
        <Route
          path="/app/agreements/new"
          exact
          element={
            <Protected>
              <MainApp appContent={<AgreementCreatePage />} />
            </Protected>
          }
        />
        <Route
          path="/app/agreements/new-bulk"
          exact
          element={
            <Protected>
              <MainApp appContent={<AgreementBulkCreate />} />
            </Protected>
          }
        />
        <Route
          path="/app/agreements/edit/"
          exact
          element={
            <Protected>
              <MainApp appContent={<AgreementCreatePage />} />
            </Protected>
          }
        />
        <Route
          path="/app/service-providers/"
          exact
          element={
            <Protected>
              <MainApp appContent={<ServiceProviderList />} />
            </Protected>
          }
        />
        <Route
          path="/app/service-providers/details/:serviceProviderId"
          exact
          element={
            <Protected>
              <MainApp appContent={<ServiceProviderDetails />} />
            </Protected>
          }
        />
        <Route
          path="/app/budget-manager/"
          exact
          element={
            <Protected>
              <MainApp appContent={<BudgetManager />} />
            </Protected>
          }
        />
        <Route
          path="/app/blog-manager"
          exact
          element={
            <Protected>
              <MainApp appContent={<Blogs />} />
            </Protected>
          }
        />
        <Route
          path="/app/blog-manager/create"
          exact
          element={
            <Protected>
              <MainApp appContent={<CreateBlogs />} />
            </Protected>
          }
        />
        <Route
          path="/app/blog-manager/edit/:blogId"
          exact
          element={
            <Protected>
              <MainApp appContent={<CreateBlogs />} />
            </Protected>
          }
        />

        <Route
          path="app/service-providers/add-businessunit"
          exact
          element={
            <Protected>
              <MainApp appContent={<AddOrganisationPage />} />
            </Protected>
          }
        />
        <Route
          path="app/add-businessunit/details/:serviceProviderId"
          exact
          element={
            <Protected>
              <MainApp
                appContent={<AddOrganisationDetail />}
              />
            </Protected>
          }
        />
        <Route
          path="app/recovery/new"
          exact
          element={
            <Protected>
              <MainApp
                appContent={<NewRecoveryPage />}
              />
            </Protected>
          }
        />
        <Route
          path="app/recovery"
          exact
          element={
            <Protected>
              <MainApp
                appContent={<RecoveryListingPage />}
              />
            </Protected>
          }
        />
        <Route
          path="app/recovery/:id"
          exact
          element={
            <Protected>
              <MainApp appContent={<RecoveryDisplayPage />} />
            </Protected>
          }
        />
        <Route
          path="app/recovery/d/:id"
          exact
          element={
            <Protected>
              <MainApp appContent={<RecoveryDisplayPage isFromDashboard={true} />} />
            </Protected>
          }
        />
        <Route
          path="app/recovery/edit/:id"
          exact
          element={
            <Protected>
              <MainApp appContent={<NewRecoveryPage />} />
            </Protected>
          }
        />
        <Route
          path="/app/recovery/locker"
          exact
          element={
            <Protected>
              <MainApp appContent={<RecoveryListingPage />} />
            </Protected>
          }
        />
        <Route
          path="/app/updatePassword"
          exact
          element={
            <Protected>
              <MainApp appContent={<UpdatePassword />} />
            </Protected>
          }
        />
        <Route
          path="/app/template/notice"
          exact
          element={
            <Protected>
              <MainApp
                appContent={
                  <NoticeList />
                }
              />
            </Protected>
          }
        />
        <Route
          path="/app/template/email"
          exact
          element={
            <Protected>
              <MainApp
                appContent={
                  <EmailList />
                }
              />
            </Protected>
          }
        />
        <Route
          path="/app/gmail-inbox"
          element={
            <Protected>
              <MainApp appContent={<GmailInbox />} />
            </Protected>
          }
        />
        <Route
          path="/app/documents"
          exact
          element={
            <Protected>
              <MainApp appContent={<Document />} />
            </Protected>
          }
        />
      </Routes>
    </Suspense>
  </MainWrapper>
);
export default RouteHandler;
